import { useMyMutation, MutationInfos, client } from '../helpers';
import {
    ApiType,
    CreateCompanyGuestInput,
    CreateMemberFamilyInput,
    DeleteCompanyGuestInput,
    DeleteMemberFamilyInput,
    UpdateCompanyGuestInput,
    UpdateMemberFamilyInput,
} from '../../apiTypes';
import { typeUsers } from './types';
import { getB2CGroupID, getDefaultContractID } from '../../../utils/user';

//======================================//
//=============== Family ===============//
//======================================//

function createMemberFamily(variables: CreateMemberFamilyInput): MutationInfos {
    const { id: contractId, ...rest } = variables;
    return {
        method: 'post',
        path: `/api/contract/${contractId}/coworkers`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_MEMBER_FAMILY,
        params: {
            users: [
                {
                    ...rest,
                    groups: [{ uuid: getB2CGroupID(), roles: ['RIDER'] }],
                },
            ],
        },
    };
}

function updateMemberFamily(variables: UpdateMemberFamilyInput): MutationInfos {
    const { id: contractId, memberId, ...rest } = variables;
    return {
        method: 'put',
        path: `/api/contract/${contractId}/people/${memberId}`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_MEMBER_FAMILY,
        params: {
            ...rest,
        },
    };
}

function deleteMemberFamily(variables: DeleteMemberFamilyInput): MutationInfos {
    const { id: contractId, memberId } = variables;
    return {
        method: 'delete',
        path: `/api/contract/${contractId}/people/${memberId}`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_MEMBER_FAMILY,
        params: {},
    };
}

//======================================//
//=============== Guests ===============//
//======================================//

function createCompanyGuest(variables: CreateCompanyGuestInput): MutationInfos {
    const { id: contractId, groupId, ...rest } = variables;
    return {
        method: 'post',
        path: `/api/contract/${contractId}/group/${groupId}/guest`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_COMPANY_GUEST,
        params: {
            ...rest,
        },
    };
}

function updateCompanyGuest(variables: UpdateCompanyGuestInput): MutationInfos {
    const { guestId, ...rest } = variables;
    return {
        method: 'patch',
        path: `/api/guests/${guestId}`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_COMPANY_GUEST,
        params: {
            ...rest,
        },
    };
}

function deleteCompanyGuest(variables: DeleteCompanyGuestInput): MutationInfos {
    const { guestId } = variables;
    return {
        method: 'delete',
        path: `/api/guests/${guestId}`,
        apiType: ApiType.ID,
        type: typeUsers.CREATE_COMPANY_GUEST,
        params: {},
    };
}

//= =========================//
//= ======== Hooks ==========//
//= =========================//

//=============== Family ===============//
export function useCreateMemberFamily(options = {}) {
    return useMyMutation(createMemberFamily, {
        ...options,
        onSuccess: (_, variables) => {
            client.invalidateQueries(`collabs${variables.id}`);
        },
    });
}

export function useUpdateMemberFamily(options = {}) {
    return useMyMutation(updateMemberFamily, {
        ...options,
        onSuccess: (_, variables) => {
            client.invalidateQueries(`collabs${variables.id}`);
        },
    });
}

export function useDeleteMemberFamily(options = {}) {
    return useMyMutation(deleteMemberFamily, {
        ...options,
        onSuccess: (_, variables) => {
            client.invalidateQueries(`collabs${variables.id}`);
        },
    });
}

//=============== Guest ===============//
export function useCreateCompanyGuest(options = {}) {
    return useMyMutation(createCompanyGuest, {
        ...options,
        onSuccess: (_, variables) => {
            client.invalidateQueries(`searchCollabsNoCacheQuery${variables.id}`);
        },
    });
}
export function useUpdateCompanyGuest(options = {}) {
    return useMyMutation(updateCompanyGuest, {
        ...options,
        onSuccess: () => {
            const contractId = getDefaultContractID();
            client.invalidateQueries(`searchCollabsNoCacheQuery${contractId}`);
        },
    });
}
export function useDeleteCompanyGuest(options = {}) {
    return useMyMutation(deleteCompanyGuest, {
        ...options,
        onSuccess: () => {
            const contractId = getDefaultContractID();
            client.invalidateQueries(`searchCollabsNoCacheQuery${contractId}`);
        },
    });
}
